import { ServerSideRowModelModule } from "ag-grid-enterprise";
import { ModuleRegistry } from '@ag-grid-community/core';
import { observer } from "mobx-react";
import useStore from "../../../../store";
import { ServerGridConfig } from "../../../../config/GridConfig";
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Notification } from "../../../../config/Global";

const ListComponent = observer(() => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const { BOOKINGINVOICE } = useStore();
	const ActionRenderer = (props) => {
		const handleDownload = async () => {
			try {
				const zohoInvoiceId = props.data.zohoInvoiceId;
				if (!zohoInvoiceId) {
					Notification.error({
						message: 'Invoice not found',
						description: 'This invoice is no longer available.',
					});
					return;
				}
				const response = await BOOKINGINVOICE.downloadInvoice(zohoInvoiceId);
				const blob = new Blob([response.data], { type: "application/pdf" });
				const url = window.URL.createObjectURL(blob);
				let filename = `Invoice_${zohoInvoiceId}.pdf`;
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			} catch (error) {
				 Notification.error({
				message: 'Download failed',
				description: 'Something went wrong while downloading your file. Please try again later.',
			});
			}
		};
		return (
			<div className="action-column">
				<Button
					type="file"
					title="Download"
					className="downloadIcon"
					onClick={handleDownload}
				>
					<FontAwesomeIcon icon={faDownload} />
				</Button>
			</div>
		);
	};
	const colDefs = [
		{
			headerName: 'Invoice No',
			field: 'invoiceNo',
			minWidth: 175
		},
		{
			headerName: 'Invoice Date',
			field: 'invoiceDate',
			minWidth: 170,
			sort: 'desc',
			valueFormatter: ({ value }) => {
				return value
				? dayjs.utc(value).tz('Asia/Kolkata').format('DD/MM/YYYY hh:mm A'): '';
			},
		},
		{
			headerName: 'Guest Name',
			field: 'guestName',
			minWidth: 150
		},
		{
			headerName: 'Guest GSTIN',
			field: 'guestGstIn',
			minWidth: 100,
		},
		{
			headerName: 'Total Amount(inc GST)',
			field: 'totalAmountWithGst',
			minWidth: 180
		},
		{
			headerName: 'Payment ID',
			field: 'gatewayPaymentId',
			minWidth: 150
		},
		{
			headerName: 'Payment Status',
			field: 'paymentStatus',
			minWidth: 100
		},
		{
			headerName: 'Settlement Status',
			field: 'settlementStatus',
			minWidth: 100
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 130,
			width: 130,
		},
	];
	return (
		<div
			className="ag-theme-quartz"
			style={{ height: 'calc(100vh - 160px)' }}
		>
			<AgGridReact
				onGridReady={BOOKINGINVOICE.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				components={{ActionRenderer}}
			/>
		</div>
	);
});

export default ListComponent;